const palette: Record<string, string> = {
    black: '#000',
    white: '#fff',
    brand01: '#3182CE',
    ui01: '#E2E8F0',
    ui02: '#1A1A1A',
    ui03: '#A0AEC0',
    ui04: '#F7FAFC',
    ui05: '#2B6CB0',
    ui06: '#6B7280',
};

export default palette;
